import { render, staticRenderFns } from "./Galerija.vue?vue&type=template&id=8b9b9696&scoped=true"
import script from "./Galerija.vue?vue&type=script&lang=js"
export * from "./Galerija.vue?vue&type=script&lang=js"
import style0 from "./Galerija.vue?vue&type=style&index=0&id=8b9b9696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9b9696",
  null
  
)

export default component.exports